/** Names a read-out shows before folding the rest into "and N others". */
const NAME_LIST_MAX = 5;

const CONJUNCTION = new Intl.ListFormat("en", {
  style: "long",
  type: "conjunction",
});

/**
 * A set of people as one sentence: "Ada", "Ada and Bob", "Ada, Bob, and Cy",
 * "Ada, Bob, Cy, Dot, Eve, and 12 others". `total` is the size of the whole
 * set when `names` holds only the part resolved so far; the fold counts
 * against it, so a partly-resolved roster never under-reports. A fold that
 * would hide exactly one name shows the name instead — "and 1 other" costs
 * the same width it saves. Nothing resolved reads as the bare count.
 */
export function formatNameList(
  names: readonly string[],
  total: number = names.length,
): string {
  const size = Math.max(total, names.length);
  const cap = size <= NAME_LIST_MAX + 1 ? size : NAME_LIST_MAX;
  const shown = names.slice(0, cap);
  const others = size - shown.length;
  if (shown.length === 0) return `${size} more`;
  if (others === 0) return CONJUNCTION.format(shown);
  return CONJUNCTION.format([
    ...shown,
    `${others} ${others === 1 ? "other" : "others"}`,
  ]);
}
